import { useContext } from 'react';
import type { AnalyticsBrowser } from '@segment/analytics-next';
import { AnalyticsContext } from './AnalyticsContext';

export function useAnalyticsContext(): AnalyticsBrowser {
  return useContext(AnalyticsContext);
}
